import axios from "../../config/axiosConfig";
import { getRawMaterialIssueChallanTransactionTakaNo } from './raw-material-issue-challan-transaction-actions';
import { getRawMaterialInwardChallans } from './raw-material-inward-challan-actions';
import { getRawMaterialInwardChallanTransaction, getRawMaterialInwardChallanTransactionTakaNo } from './raw-material-inward-challan-transaction-actions';
import { CREATE_RAW_MATERIAL_ISSUE_CHALLAN, GET_RAW_MATERIAL_ISSUE_CHALLANS, RAW_MATERIAL_ISSUE_CHALLAN_REQUEST, UPDATE_RAW_MATERIAL_ISSUE_CHALLAN, 
  DELETE_RAW_MATERIAL_ISSUE_CHALLAN, RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE } from "../types";

export const getRawMaterialIssueChallans = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/raw-material-issue-challan/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_RAW_MATERIAL_ISSUE_CHALLANS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createRawMaterialIssueChallan = (rawMaterialIssueChallan) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST });
      const newRawMaterialIssueChallan = {
        ...rawMaterialIssueChallan
      };
      return axios.post("/raw-material-issue-challan/add", newRawMaterialIssueChallan,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_RAW_MATERIAL_ISSUE_CHALLAN, payload: response.data });
          dispatch(getRawMaterialIssueChallanTransactionTakaNo());
          dispatch(getRawMaterialInwardChallans());
          dispatch(getRawMaterialInwardChallanTransaction());
          dispatch(getRawMaterialInwardChallanTransactionTakaNo());
        } else {
          dispatch({
            type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE,
            error: "Raw Material Issue Challan Create Failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateRawMaterialIssueChallan = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST });
      const { auth } = getState();
      return axios.put("/raw-material-issue-challan/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_RAW_MATERIAL_ISSUE_CHALLAN,
            payload: { id, data: response.data },
          });
          dispatch(getRawMaterialIssueChallanTransactionTakaNo());
          dispatch(getRawMaterialInwardChallans());
          dispatch(getRawMaterialInwardChallanTransaction());
          dispatch(getRawMaterialInwardChallanTransactionTakaNo());
        } else {
          dispatch({
            type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE,
            error: "Raw Material Issue Challan update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteRawMaterialIssueChallan = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST });
      const { auth } = getState();
      return axios.delete(`/raw-material-issue-challan/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_RAW_MATERIAL_ISSUE_CHALLAN, id: id });
          dispatch(getRawMaterialIssueChallanTransactionTakaNo());
          dispatch(getRawMaterialInwardChallans());
          dispatch(getRawMaterialInwardChallanTransaction());
          dispatch(getRawMaterialInwardChallanTransactionTakaNo());
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};